import React from 'react';

interface DecorativeIconProps {
  className?: string;
}

const DecorativeIcon: React.FC<DecorativeIconProps> = ({ className = '' }) => {
  return (
    <svg 
      width="261" 
      height="208" 
      viewBox="0 0 261 208" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        opacity="0.2" 
        d="M183.527 53.1298C183.527 53.1298 225.069 83.884 277.7 120.574C297.104 134.1 310.618 160.694 300.615 178.931C281.336 214.078 156.628 97.9176 156.628 97.9176C153.54 130.972 162.563 180.246 139.125 205.378C135.337 209.44 128.68 208.682 126.035 203.797C109.956 174.096 117.176 96.7254 117.176 96.7254C117.176 96.7254 62.4338 163.117 44.4128 176.776C37.3085 182.162 29.7978 186.512 21.6399 188.885C10.562 192.107 0.501153 181.36 3.90064 170.345C20.1907 117.551 93.0571 56.6161 93.0571 56.6161C93.0571 56.6161 15.0065 6.59552 1.673 -17.1087C-1.94581 -23.5444 0.260329 -29.5977 8.73862 -35.0496C34.3584 -51.5234 84.5681 11.3557 109.199 22.7986C111.951 2.13178 115.288 -83.1627 147.741 -71.9969C168.282 -62.3304 160.81 31.0387 160.81 31.0387C160.81 31.0387 256.925 -70.8197 263.958 -26.6505C268.123 -0.499603 183.527 53.1298 183.527 53.1298Z" 
        fill="#00C49A"
      />
    </svg>
  );
};

export default DecorativeIcon;
